import type { ReactNode } from 'react';
import { cn } from '../../../../lib/utils';
import { Skeleton } from '../../../feedback/Skeleton';
import { DENSITY_CELL, type Density } from '../styles';
import type { DataGridColumn } from '../types';

export interface SkeletonRowsProps<T> {
  count: number;
  columns: DataGridColumn<T>[];
  density: Density;
}

/**
 * Loading placeholder rows rendered while `isLoading` is true and no
 * data has arrived yet. One `<tr>` per skeleton row, one `<Skeleton>`
 * per column — mimicking the real layout so the transition to actual
 * data feels instant.
 */
export function SkeletonRows<T>({
  count,
  columns,
  density,
}: SkeletonRowsProps<T>): ReactNode {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <tr key={`skeleton-${i}`} className="border-b border-neutral-100">
          {columns.map((col) => (
            <td key={col.id} className={cn(DENSITY_CELL[density])}>
              <Skeleton className="h-4 w-full max-w-[180px]" />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}
